<section class="auth-container">
  <div class="auth-content">
    <!-- Main Card -->
    <div class="auth-form-section">
      <div class="auth-card">
        <!-- Logo & Header -->
        <div class="auth-header">
          <img ngSrc="../../../assets/img/brand/salesmax.png" width="2251" height="559" priority
            class="auth-logo" alt="Salesmax.ai" />
          <h1 class="auth-title">Verify Your Number</h1>
          <p class="auth-subtitle">Enter the 6-digit code we sent to your phone</p>
        </div>

        <!-- OTP Form -->
        <form class="auth-form">
          <div class="otp-inputs">
            <mat-form-field class="otp-digit">
              <input matInput [formControl]="digit1" #digit1el type="tel" pattern="\d*" maxlength="1">
            </mat-form-field>
            <mat-form-field class="otp-digit">
              <input matInput [formControl]="digit2" #digit2el type="tel" pattern="\d" maxlength="1">
            </mat-form-field>
            <mat-form-field class="otp-digit">
              <input matInput [formControl]="digit3" #digit3el type="tel" pattern="\d" maxlength="1">
            </mat-form-field>
            <mat-form-field class="otp-digit">
              <input matInput [formControl]="digit4" #digit4el type="tel" pattern="\d" maxlength="1">
            </mat-form-field>
            <mat-form-field class="otp-digit">
              <input matInput [formControl]="digit5" #digit5el type="tel" pattern="\d" maxlength="1">
            </mat-form-field>
            <mat-form-field class="otp-digit">
              <input matInput [formControl]="digit6" #digit6el type="tel" pattern="\d" maxlength="1"
                (keydown.enter)="onKeydown($event)" (keyup.enter)="submit()">
            </mat-form-field>
          </div>

          <button
            class="auth-button"
            type="button"
            (click)="submit()"
            [disabled]="(busy | async) || (!digit1.valid || !digit2.valid || !digit3.valid || !digit4.valid || !digit5.valid || !digit6.valid)">
            @if (!(busy | async)) {
              <span>Continue</span>
            }
            @if (busy | async) {
              <mat-spinner [diameter]="24"></mat-spinner>
            }
          </button>

          @if (errorMessage | async) {
            <div class="error-message">
              <mat-icon>error_outline</mat-icon>
              <span>{{ errorMessage | async }}</span>
            </div>
          }
        </form>

        <!-- Footer Links -->
        @if (!(busy | async)) {
          <div class="auth-footer">
            <p class="footer-text">
              Didn't receive the code?
              <a (click)="retryOtp()" [ngClass]="{'disable-retry': counter > 0}" class="footer-link">
                Retry
              </a>
              @if (counter > 0) {
                <span class="counter-text">in {{counter}}s</span>
              }
              <span class="divider">or</span>
              <a (click)="goBack()" class="footer-link">Edit Number</a>
            </p>
          </div>
        }
      </div>
    </div>

    <!-- Right Side - Illustration -->
    <div class="auth-illustration-section">
      <div class="illustration-content">
        <div class="otp-channels">
          <div class="channel-icon">
            <mat-icon>sms</mat-icon>
            <span>SMS</span>
          </div>
          <div class="channel-icon">
            <mat-icon>chat</mat-icon>
            <span>WhatsApp</span>
          </div>
          <div class="channel-icon">
            <mat-icon>email</mat-icon>
            <span>Email</span>
          </div>
        </div>
        <h2 class="illustration-title">Secure Verification</h2>
        <p class="illustration-text">We've sent a one-time code to verify your phone number and keep your account secure</p>
      </div>
    </div>
  </div>
</section>
